<form [formGroup]="form" style="height: 100%;">
    <div class="SnapshotContainer">
        <div class="SnapshotLeftArea">
            <div class="SnapshotTopFieldArea">
                <div class="SnapshotFields" id="SnapshotFields" style="width: 11%;">
                    <div class="SnapshotFieldheading">SNAPSHOT NAME</div>
                    <div class="lineSeparation"></div>
                    <input type="text" #snapshotInput formControlName="snapshotName" minlength="5"
                        placeholder="Enter Snapshot Name" class="SnapshotFieldInput snapshotName"
                        id="SnapshotNameFieldInput{{id}}">
                </div>

                <!-- <div class="SnapshotFields" id="SnapshotFields" style="width: 12%;">
                    <div class="SnapshotFieldheading">SNAPSHOT TYPE</div>
                    <div class="lineSeparation"></div>
                    <select formControlName="snapshotType" class="SnapshotFieldInput" #snapshotTypeSelect
                        style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                        <option value="" disabled selected style="display: none;">Select</option>
                        <option *ngFor="let type of snapshotTypes" [value]="type.name">{{type.name}}</option>
                    </select>
                </div> -->

                <div (mouseleave)="showStudyNameDropdown = false" class="SnapshotFields" id="SnapshotFieldsStudyNames"  style="width: 12%;">
                    <div class="SnapshotFieldheading">STUDY NAMES</div>
                    <div class="lineSeparation"></div>
                    <div style="height: 40%;  margin-top:1vh;">
                        <button class="drop-toggle btn flat" (click)="showStudyNameDropdown=!showStudyNameDropdown"
                            style="display: flex; flex-direction: row; padding: 1% 3%;align-items: center;height: 100%;">
                            <span id="studyNamesArea" *ngIf="checkedList.length<=0"
                                style="font-weight: bold;font-size: 0.7rem;">Select</span>
                            <span id="studyNamesArea" *ngIf="checkedList.length>0" title="{{checkedList}}">{{checkedList.join(', ')}}</span>
                            <div class="downarrow" style="font-weight: bold;"></div>
                        </button>
                        <div class="drop-show" *ngIf="showStudyNameDropdown">
                            <label *ngFor="let a of studyNames" class="drop-study-name">
                                <input [type]="'radio'" [checked]="a.selected != null ?a.selected : false"
                                    class="studyNameRadio" (change)="getSelectedValueStudyName(a,a.name)" />
                                <span title="{{a.name}}">{{a.name}}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- <div class="SnapshotFields" id="SnapshotFieldsNumber_of_Widgets">
                    <div class="SnapshotFieldheading">NUMBER OF WIDGETS</div>
                    <div class="lineSeparation"></div>
                    <select [(ngModel)]="numberOfWidget" class="SnapshotFieldInput" formControlName="widgetTypeForm"
                        #widgetTypeSelect (change)="numberOfWidgetsCLick($event)"
                        style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                        <option value="" disabled selected style="display: none;">Select</option>
                        <option *ngFor="let type of numberOfWidgets" [value]="type.name">{{type.name}}</option>
                    </select>
                </div> -->

                <!-- <div class="SnapshotFields" id="SnapshotFieldsSnapshot_Layout" style="margin-right: 0%;">
                    <div class="SnapshotFieldheadingGroup">
                        <div class="SnapshotFieldheading" style="width: 90%;">SNAPSHOT LAYOUT </div>
                        <div class="expand_Image" (click)="showWidgetLayout()">
                        </div>
                    </div>
                    <div class="lineSeparation"></div>
                    <div class="SnapshotFieldInput SnapshotFieldInputLayout" (click)="showWidgetLayout()"
                        aria-placeholder="Select layout from expand"></div>
                </div> -->
                <div class="SnapshotFields disabled" id="SnapshotFieldsDocument_Repository" style="width: 27%;">
                    <div class="SnapshotFieldheading">DOCUMENT REPOSITORY</div>
                    <div class="lineSeparation" style="margin-top: 0.2%;"></div>
                    <div class="DocDP DF" style="margin-top: 0.4em;height: 40%;">
                        <div class="docField" style="width:32%">
                            <div class="FFCaption DF" style="margin-right: 0.5vw;">Folder</div>
                            <select formControlName="docFolderType" class="SnapshotFieldInputDoc" #docFolderTypeSelect
                                style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                                <option value="" disabled selected style="display: none;">Folder 1</option>
                                <option *ngFor="let type of docRepFolderTypes" [value]="type.name">{{type.name}}
                                </option>
                            </select>
                        </div>
                        <div class="docField" style="width:32%">
                            <div class="FFCaption DF" style="margin-right: 0.5vw;">File</div>
                            <select formControlName="docFileType" class="SnapshotFieldInputDoc" #docFolderTypeSelect
                                style="font-size: 0.65rem; font-weight: 600; font-family: 'KantarBrown-Regular';">
                                <option value="" disabled selected style="display: none;">File 1</option>
                                <option *ngFor="let type of docRepFileTypes" [value]="type.name">{{type.name}}
                                </option>
                            </select>
                        </div>
                        <div class="docField" style="width:36%">
                            <div class="FFCaption DF" style="margin-right: 0.5vw;">New File</div>
                            <input formControlName="newFileText" type="text" style="width: 60%;"
                                placeholder="New file name" #newFileText>
                        </div>
                    </div>
                    <div class="DocDPBtn DF">
                        <div class="DocBtnDiv">
                        <div class="button-img save"></div>
                        <div class="SnapshotButton" (click)="save()">Save</div>
                    </div>
                    <div class="DocBtnDiv">
                        <div class="button-img upload"></div>
                        <div class="SnapshotButton" (click)="save()">Upload</div>
                    </div>
                    <div class="DocBtnDiv">
                        <div class="button-img delete"></div>
                        <div class="SnapshotButton" (click)="save()">Delete</div>
                    </div>
                    </div>
                </div>

                <div class="SnapshotFields" id="SnapshotFieldsSave_Selection" style="width: 22%;">
                    <div class="SnapshotFieldheading">SAVE SELECTION</div>
                    <div class="lineSeparation"></div>
                    <div class="save-selection-area">
                        <div *ngFor="let selection of saveSelection" style="margin-top: 1vh;">
                            <input (change)="saveSelectionChecked(selection,$event)" type="checkbox"
                                id="{{selection.value}}" class="alignCheckClick" [checked]="selection.selected">
                            <label for="{{selection.value}}">{{selection.name}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="snapshotMiddleFieldArea">
                <div class="snapshot-feature-area">
                    <div class="snapshot-features">
                        SNAPSHOT FEATURES
                    </div>
                    <div class="features-set1-area">
                        <div class="SnapshotFields" id="SnapshotFieldsOutput_Configuration"
                            style="width: 25%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">OUTPUT CONFIGURATION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput" id="outputconfiguration">
                                <!-- <input type="radio" id="admin" [checked]="adminDefinedFlag" class="alignClick" name="option" value="admin">
                        <label for="admin">Admin Defined</label><br>
                        <input type="radio" id="user" [checked]="!adminDefinedFlag" class="alignClick" name="option" value="user">
                        <label for="user">User Defined</label> -->
                                <div *ngFor="let config of outputconfiguration">
                                    <div (click)="outputconfigchecked(config)">
                                        <input type="radio" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected" value="{{config.value}}">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsFilter_Function"
                            style="width: 25%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">FILTER FUNCTION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div class="FFCaption">Answer Base</div>
                                <div id="FF" (click)="toggleAnswerBase()">
                                    <div [style]="answerBaseInput?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        id="FFyesno" class="toggleButtons">Yes</div>
                                    <div [style]="!answerBaseInput?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        id="FFyesno" class="toggleButtons">No</div>
                                </div>

                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsStatic_Text"
                            style="width: 25%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">STATIC TEXT</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div id="ST">
                                    <div id="STyesno"
                                        [style]="showStaticTextAreaFlag?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        class="toggleButtons" (click)="showStaticTextArea($event)">Yes</div>
                                    <div id="STyesno"
                                        [style]="!showStaticTextAreaFlag?'background-Color:#8029B6;color:white':'background-Color:transparent;color:black'"
                                        class="toggleButtons" (click)="hideStaticTextArea($event)">No</div>
                                </div>
                                <!-- <input type="text" *ngIf="showStaticTextAreaFlag" class="StaticTextArea"
                            placeholder="Static Text"> -->
                                <textarea *ngIf="showStaticTextAreaFlag" formControlName="staticText" maxlength="150"
                                    #staticText (input)="onStaticTextChanged($event)" class="StaticTextArea"
                                    placeholder="Static Text"></textarea>
                            </div>
                        </div>
                        <!-- <div class="SnapshotFields" id="SnapshotFieldsSticky_Default_selection" style="width: 25%;">
                            <div class="SnapshotFieldheading">STICKY/DEFAULT SELECTION</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div *ngFor="let config of stickyDefaultSelection">
                                    <div (click)="stickyDefaultchecked(config)">
                                        <input type="radio" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="SnapshotFields" id="SnapshotFieldsUser_Management" style="width: 25%;">
                            <div class="SnapshotFieldheading">USER MANAGEMENT</div>
                            <div class="lineSeparation"></div>
                            <div class="SnapshotFieldInput">
                                <div *ngFor="let config of userManagementSelection">
                                    <div (click)="userManagementchecked(config,$event)">
                                        <input type="checkbox" id="{{config.value}}" class="alignCheckClick"
                                            [checked]="config.selected">
                                        <label for="{{config.value}}">{{config.name}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="features-set2-area">
                        <div class="SnapshotFields" id="SnapshotFieldsComparison_Points"
                            style="width: 18%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">COMPARISON POINTS</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of comparisonPoints">
                                    <input (change)="comparisionChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected">
                                    <label for="{{comparison.value}}">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsTypes_of_Significance"
                            style="width: 19%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">TYPES OF SIGNIFICANCE</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of significance">
                                    <input (change)="signiFicanceTypeChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected">
                                    <label for="{{comparison.value}}">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsMultiple_Confidence_Levels"
                            style="width: 24%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">MULTIPLE CONFIDENCE LEVELS</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of multipleConfidence">
                                    <input (change)="multipleConfidenceChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected">
                                    <label for="{{comparison.value}}">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsCustom_Content"
                            style="width: 17%; margin-right: 1%;">
                            <div class="SnapshotFieldheading">CUSTOM CONTENT</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let Content of customContentSelection">
                                    <input (change)="customContentChecked(Content,$event)" type="checkbox"
                                        id="{{Content.value}}" class="alignCheckClick"
                                        [checked]="Content.selected">
                                    <label for="{{Content.value}}">{{Content.name}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="SnapshotFields" id="SnapshotFieldsExport" style="width: 18%;">
                            <div class="SnapshotFieldheading">EXPORT</div>
                            <div class="lineSeparation"></div>
                            <div class="comparison-field-area">
                                <div *ngFor="let comparison of export">
                                    <input (change)="exportChecked(comparison,$event)" type="checkbox"
                                        id="{{comparison.value}}" class="alignCheckClick"
                                        [checked]="comparison.selected">
                                    <label for="{{comparison.value}}">{{comparison.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="features-set3-area">
                        <div class="SnapshotFields DF">
                            <div class="additionalCBDiv DF" *ngFor="let addCB of additionalCheckBoxSelection;let i = index;let isLast = last"
                            [ngStyle]="isLast ? {'width': '25%'} : {}" [ngClass]="{'disabled': (moduleConfigPropertiesDisplay[0] && additionalCheckBoxSelection[i].value !== undefined &&
                            moduleConfigPropertiesDisplay[0][additionalCheckBoxSelection[i].value] === 'NA')}">
                                <input (change)="additionalCheckBoxchecked(addCB,$event)" type="checkbox"
                                    id="{{addCB.value}}" class="alignCheckClick" style="top: 0;"
                                    [checked]="addCB.selected">
                                <label for="{{addCB.value}}">{{addCB.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="snapshotTypeArea">
            <div class="snapshot-features">
                SELECTION PANEL
            </div>
            <div class="selectionPanelArea">
                <div class="SnapshotFields" id="SnapshotFieldsSelection_Panel_Headers">
                    <div class="SnapshotFieldheading">SNAPSHOT TYPE</div>
                    <div class="lineSeparation"></div>
                    <div class="snapshot-type-area">
                        <div class="snapshot-type-checkbox">
                            <div class="singleBrandType">
                                <input type="checkbox" id="singleBrand" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'singleBrand')">
                                <label class="snapshotTypeName" for="singleBrand">Single Brand</label>
                                <div class="expand-icon" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData" id="singleBrandType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showSingleBrand"></div>
                            <div class="sub-div" *ngIf="showSingleBrand" style=" margin-left: 10%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">ENTRY POINTS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area">
                                        <div *ngFor="let entryPoint of entryPointsSB" class="checkboxClass">
                                            <input *ngIf="entryPoint.variable_code !=''"
                                                (change)="ExportEntryPointsClicks(entryPoint, entryPointsSB,$event)"
                                                type="checkbox" id="{{entryPoint.variable_label}}"
                                                class="alignCheckClick" [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">DIMENSIONS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsSB">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsSB,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span>Please do not add Time Period and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiBrandType">
                                <input type="checkbox" id="multiBrand" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiBrand')">
                                <label class="snapshotTypeName" for="multiBrand">Multiple Brands</label>
                                <div class="expand-icon" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData" id="multiBrandType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiBrand"></div>
                            <div class="sub-div" *ngIf="showMultiBrand" style=" margin-left: 10%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">ENTRY POINTS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area">
                                        <div *ngFor="let entryPoint of entryPointsMB" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMB,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">DIMENSIONS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMB">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMB,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span>Please do not add Time Period and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiCategoryType">
                                <input type="checkbox" id="multiCategory" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiCategory')">
                                <label class="snapshotTypeName" for="multiCategory">Multiple Categories</label>
                                <div class="expand-icon" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData" id="multiCategoryType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiCategory"></div>
                            <div class="sub-div" *ngIf="showMultiCategory" style=" margin-left: 10%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">ENTRY POINTS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area">
                                        <div *ngFor="let entryPoint of entryPointsMC" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMC,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">DIMENSIONS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMC">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMC,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span> Please do not add Time Period, Categories and Brand as Entry Point or
                                        Dimensions</div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>

                        <div class="snapshot-type-checkbox">
                            <div class="multiMarketType">
                                <input type="checkbox" id="multiMarket" class="alignCheckClick"
                                    (click)="SnapshotTypeClick($event, 'multiMarket')">
                                <label class="snapshotTypeName" for="multiMarket">Multiple Markets</label>
                                <div class="expand-icon" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData" id="multiMarketType" (click)="StudytypeExpandClicks($event)">
                                </div>
                            </div>
                            <div class="lineSeparation" *ngIf="!showMultiMarket"></div>
                            <div class="sub-div" *ngIf="showMultiMarket" style=" margin-left: 10%;">
                                <!-- Entry Points -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">ENTRY POINTS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="entry-points-field-area">
                                        <div *ngFor="let entryPoint of entryPointsMM" class="checkboxClass">
                                            <input (change)="ExportEntryPointsClicks(entryPoint, entryPointsMM,$event)"
                                                *ngIf="entryPoint.variable_code !=''" type="checkbox"
                                                id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                                [checked]="entryPoint.is_selected">
                                            <label *ngIf="entryPoint.variable_code !=''"
                                                for="{{entryPoint.variable_label}}">{{
                                                entryPoint.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- Dimensions -->
                                <div class="SnapshotFields" id="SnapshotFields">
                                    <div class="SnapshotFieldheading">DIMENSIONS</div>
                                    <div class="lineSeparation"></div>
                                    <div class="dimensions-field-area">
                                        <!-- Dimension checkboxes go here -->
                                        <div *ngFor="let dimension of dimensionsMM">
                                            <input (change)="ExportDimensionsClicks(dimension, dimensionsMM,$event)"
                                                *ngIf="dimension.variable_code !=''" type="checkbox"
                                                id="{{dimension.variable_label}}" class="alignCheckClick"
                                                [checked]="dimension.is_selected">
                                            <label *ngIf="dimension.variable_code !=''"
                                                for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="sub-div-note-area">
                                    <div class="note-image"></div>
                                    <div class="sub-div-note"><span style="color: black; font-weight: bold;">Note:
                                        </span> Please do not add Time Period, Brands and Market as Entry Point or
                                        Dimensions.<br></div>
                                </div>
                                <div class="lineSeparation"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="selection-panel-area">
                <div class="selection-panel-header">
                    SELECTION PANEL HEADERS
                </div>
                <div class="entry-points-area">
                    <div class="SnapshotFields" id="SnapshotFields">
                        <div class="SnapshotFieldheading">ENTRY POINTS</div>
                        <div class="lineSeparation"></div>
                        <div class="entry-points-field-area">
                            <div *ngFor="let entryPoint of entryPoints" class="checkboxClass">
                                <input type="checkbox" id="{{entryPoint.variable_label}}" class="alignCheckClick"
                                    [checked]="entryPoint.is_selected">
                                <label for="{{entryPoint.variable_label}}">{{
                                    entryPoint.variable_code}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dimensions-area">
                    <div class="SnapshotFields" id="SnapshotFields">
                        <div class="SnapshotFieldheading">DIMENSIONS</div>
                        <div class="lineSeparation"></div>
                        <div class="dimensions-field-area">
                            <div *ngFor="let dimension of dimensions">
                                <input type="checkbox" id="{{dimension.variable_label}}" class="alignCheckClick"
                                    [checked]="dimension.is_selected">
                                <label
                                    for="{{dimension.variable_label}}">{{dimension.variable_code==""?"None":dimension.variable_code}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            </div>
        </div>
    </div>

    <div class="snapshotBottomFieldArea">
        <div class="SnapshotButtonFields" (click)="clearAll()">
            <div class="button-img clearAll"></div>
            <div class="SnapshotButton">Reset</div>
        </div>
        <div class="SnapshotButtonFields" (click)="delete()">
            <div class="button-img delete"></div>
            <div class="SnapshotButton">Delete</div>
        </div>
        <!-- <div class="SnapshotButtonFields">
            <div class="button-img save"></div>
            <div class="SnapshotButton" (click)="save()">Save</div>
        </div> -->
        <div class="SnapshotButtonFields" [class.disabled]="!isSubmit" (click)="submit()">
            <div class="button-img submit"></div>
            <div class="SnapshotButton">Submit</div>
        </div>
    </div>
</form>
<app-shared-popup-snapshot *ngIf="showPopUp" [popUpParameter]="'WidgetLayout'" [parentSelectedWidget]="selectedwidget"
    (selectedwidget)="receiveLayoutWidget($event)" [showInputPopUp]="false"
    (closePopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<app-shared-popup-snapshot *ngIf="showErrorPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
    [popUpMessage]="popUpMessage" [showInputPopUp]="false" [showErrorPopUp] = "true"
    (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<app-shared-popup-snapshot *ngIf="showSubmitPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
    [popUpMessage]="popUpMessage" [showInputPopUp]="false" [showErrorPopUp] = "true"
    (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>
<!-- delete confirmation popup -->
<div *ngIf="showDeletePopup">
    <div class="overlay"></div>
    <app-delete-popup (dataEvent)="receivedDeleteConfirmation($event)"></app-delete-popup>
</div>